import { useAuth0 } from '@auth0/auth0-react';
import * as React from 'react';
import { useEffect } from 'react';
import { HubActions } from '../../apis/Hub.Base';
import { ApplicationState } from '../../store/stores/ApplicationState';
import { UserActions } from '../../store/stores/players/PlayerStore.Actions';
import { ErrorBound } from '../errors/ErrorBound';
import { ErrorPage } from '../errors/ErrorPage';
import { Library } from '../library';
import { Rules } from '../rules';
import { ToastContainer } from '../toasts/ToastContainer';
import { SiteNavigation } from './nav/SiteNavigation';
import { Splash } from './Splash';
import { LibraryActions } from '../../store/stores/library/LibraryStore.Actions';
import { Account } from '../account';
import { ComingSoon } from '../filtering/ComingSoon';
import { GameMasterGuide } from '../gamemasterguide';
import { Setting } from '../setting';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { Adventures } from '../collection/adventures';
import { Characters } from '../collection/characters';
import { AdventureActions } from '../../store/stores/adventures/AdventureStore.Actions';
import { useAppDispatch, useAppSelector } from '../../store/configureStore';
import { AdventureHub } from '../../apis/account/Hub.Adventure';
import { useLocalStorage } from '@uidotdev/usehooks';
import { RedirectPayload, RedirectionHelpers } from '../../entities/site/RedirectPayload';

export const App: React.FC = () => {
    const { isAuthenticated, isLoading, handleRedirectCallback } = useAuth0();
    const navigate = useNavigate();
    const { allTagsLoaded } = useAppSelector(app => app.library);
    const hub = AdventureHub.Instance();
    const location = useLocation();
    const [[redirectKey, redirectTo], setRedirecter] = useLocalStorage<RedirectPayload>(RedirectionHelpers.redirectionKey, []);

    const dispatch = useAppDispatch();
    const onLogin = async () => {
        if (window.location.search == "") {
            return;
        }
        
        const result = await handleRedirectCallback(window.location.href);
        if (!RedirectionHelpers.isRedirectUrlState(result.appState)) {
            return;
        }

        const cryptoText = result.appState.cryptoText;
        if (cryptoText != redirectKey) {
            return;
        }

        setRedirecter([]);
        if (redirectTo != null) {
            navigate(redirectTo);
        }
    }

    useEffect(() => {
        onLogin();
    }, [location, navigate]);

    useEffect(() => {
        if (isAuthenticated && hub != null) {
            dispatch(HubActions.hubOn(AdventureHub.name));
            dispatch(AdventureActions.getAdventures());
        }
    }, [dispatch, isAuthenticated, hub]);

    useEffect(() => {
        if (isAuthenticated && !isLoading) {
            dispatch(UserActions.getUserAccountData());
        }
        else if (!isLoading) {
            dispatch(UserActions.clearUserAccountData());
        }
    }, [dispatch, isAuthenticated, isLoading]);

    useEffect(() => {
        if (!allTagsLoaded) {
            dispatch(LibraryActions.loadTags());
        }
    }, [dispatch, allTagsLoaded]);

    
    const me = useAppSelector((app: ApplicationState) => app.player.me);
    useEffect(() => {
        const mustCreateName = isAuthenticated && me != null && me.displayName == "";
        if (mustCreateName) {
            navigate("/Profile/CreateName");
        }
    }, [dispatch, me]);
    return (
        <ErrorBound>
            <SiteNavigation />
            <ToastContainer />
            <AppContents />
        </ErrorBound>
    );
}

const AppContents: React.FC = () => (
    <Routes>
        <Route path='Error/*' element={<ErrorPage />} />
        <Route path='Setting/*' element={<Setting />} />
        <Route path='Rules/*' element={<Rules />} />
        <Route path='Guide/*' element={<GameMasterGuide />} />
        <Route path='Library/*' element={<Library />} />
        <Route path='Profile/*' element={<Account />} />
        <Route path='Adventures/*' element={<Adventures />} />
        <Route path='Characters/*' element={<Characters />} />
        <Route path='ComingSoon' element={<ComingSoon />} />
        <Route path="/*" element={<><Splash /></>} />
    </Routes>
);